var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-image-thumbnail aspect-square border rounded border-secondary-20 flex items-center justify-center"},[_c('img',{staticClass:"max-w-full max-h-full",attrs:{"src":_vm.imageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }